import React from 'react';

import Table from '../../../../Table';
import Pagination from '../../../../Pagination';

import LenderService from '../../../../../services/LenderService';
import usePagination from '../../../../../hooks/usePagination';
import downloadDocument from '../../../../../helpers/downloadDocument';

const cols = [
  {
    title: 'Date',
    keys: ['date'],
    type: 'date',
  },
  {
    title: 'Number',
    keys: ['pixel_number'],
  },
  {
    title: 'Amount',
    keys: ['amount'],
    type: 'currency',
  },
  {
    title: 'Status',
    keys: ['status'],
    type: 'badge',
  },
  {
    title: 'CSV',
    keys: ['document_id'],
    type: 'button',
    label: () => 'CSV Statement',
    isVisible: (row) => !!row.document_id,
    onClick: (row) => downloadDocument(row.document_id),
  },
  {
    title: 'PDF',
    keys: ['report_pdf_id'],
    type: 'button',
    label: () => 'PDF Statement',
    isVisible: (row) => !!row.report_pdf_id,
    onClick: (row) => downloadDocument(row.report_pdf_id),
  },
];

export default function Distributions({ lenderId }) {
  const {
    currentPage,
    switchToPage,
    pageTotal,
    isFetching,
    data: distributions,
  } = usePagination({
    queryKey: ['distributions', lenderId],
    queryFn: LenderService.getLenderDistributions,
    queryFnArgs: { lenderId },
    enabled: !!lenderId,
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
        Distributions
      </h2>
      <Table
        cols={cols}
        rows={distributions?.items}
        title=""
        isFetching={isFetching}
        minHeight={565}
      />
      <Pagination
        pageTotal={pageTotal}
        switchToPage={switchToPage}
        currentPage={currentPage}
      />
    </div>
  );
}
